<template>
    <div class="s_main">
    	<h1 style="color: gray;">Abstract Status</h1>
    <Table border :context="self" :columns="colums" :data="papers"  no-data-text="No data"></Table>
    </div>
</template>
<script>
  import  'iview/src/styles/common/iconfont/fonts/ionicons.eot'
  import 'iview/src/styles/common/iconfont/fonts/ionicons.svg'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.ttf'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.woff'
    export default {
        data () {
            return {
            	    cid:2006,
            	    uid:0,
                self: this,
                colums: [
                    {
                        title: 'NO',
                        key: 'paperNo'
                    },
                    {
                        title: 'Topic',
                        key: 'paperType'
                    },
                    {
                        title: 'Presenting Type',
                        key: 'paperForm'
                    },
                    {
                        title: 'Title',
                        key: 'paperTitle'
                    },
                    {
                        title: 'Author',
                        key: 'paperTitle',
                        render (row, column, index) {
                        	let first = "";
                        	for(var i = 0;i < row.links.length;i++){
                        		if(row.links[i].plFirstFl=="1"){
                        			first = row.links[i].author.uFirstPy+" "+row.links[i].author.uLastPy;
                        		}
                        		break;
                        	}
                            return  first;
                        }
                    },
                      {
                        title: 'Status',
                        key: 'paperStatus',
                        render (row, column, index) {
                        	 if(row.paperStatus==undefined) return '';
                        	    let status = ['Submission incomplete','Submitted'];
                            let cur_status =     status[row.paperStatus];
                            return   cur_status;
                        }

                    },
                      {
                        title: 'Accepted result',
                        key: 'paperCheck' ,
                        render (row, column, index) {
                        	     if(row.paperCheck==undefined) return '';
                             let checkstatus = ['To be reviewed','Under review','Approved','Rejected'];
                             let cur_status =     checkstatus[row.paperCheck];
                             return cur_status;
                         }
                    },
                    {
                        title: 'Action',
                        key: 'action',
                        width: 150,
                        align: 'center',
                        render (row, column, index) {
//                          return `<i-button type="primary" size="small" @click="show(${index})">View</i-button> <i-button type="error" size="small" @click="remove(${index})">Delete</i-button>`;
// if(row.paperStatus=="0"){
   return `<i-button type="primary" size="small" @click="modify(${index})">Modify</i-button>`;
// }else
// {
// 	return "";
// }
                        }
                    }
                ],
                papers: [
                ]
            }
        },
        methods: {
            show (index) {
                this.$Modal.info({
                    title: 'Abstract detail',
                    content: `Title：${this.papers[index].paperTitle}<br>NO：${this.papers[index].paperNo}`
                })
            },
            modify (index) {
            	      let pid =  this.papers[index].paperId ;
                   localStorage.setItem('paperId',pid)
		        this.$router.push('/home_en/2006/submit/Abstract');
            },
            remove (index) {
                this.papers.splice(index, 1);
            }
        },
        mounted() {
				this.cid = 2006;
				 let userStore = JSON.parse(localStorage.getItem('user'));
		      if(userStore != undefined && userStore != null){
		      	this.uid = userStore.uId;
		      }
				this.language = this.$route.params.language;
				//获取会议对应的正文投稿配置
				this.postHttp('/medapp/api/paper/getpaperslist', {
					cid: this.cid,
					uid: this.uid
				}).then((result) => {
					let data = '';
					if(result.data.papers != null) {
						this.papers = result.data.papers;
						return;
					}

				})
			},
    }
</script>
<style scoped>
	.s_main {
		color: #000000;
		width: 1200px;
		font-size: 16px;
		border: 0px solid #eeeeee;
		margin: 90px auto -40px;
		padding: 5px;
		min-height: 20px;
	}
</style>



// WEBPACK FOOTER //
// Status.vue?4676d79c